import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { SUBSCRIPTION_PLAN } from 'constants/paths';

import { ReactComponent as EmptyPageIcon } from 'assets/icons/EmptyPageIcon.svg';

import { Button } from 'components/_basic/Button/Button';

import styles from './EmptyPage.module.scss';

export const EmptyPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickViewPlans = () => {
    navigate(SUBSCRIPTION_PLAN);
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.containerInner}>
        <Box className={styles.imageWrapper}>
          <EmptyPageIcon />
        </Box>
        <Typography className={styles.containerInnerContent}>{t('emptyPaymentsPageText')}</Typography>
        <Button color="secondary" variant="contained" onClick={handleClickViewPlans}>
          {t('viewPlans')}
        </Button>
      </Box>
    </Box>
  );
};
